export default __webpack_public_path__ + "static/media/smallcase-partner.8b6b3213.svg";